export default class SeatTrade {
  availableSeatCount = ''
  details = {}
  flightId = ''
}
